var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.1706 14.0853C28.1706 6.30537 21.8652 0 14.0853 0C6.30537 0 0 6.30537 0 14.0853C0 21.1169 5.14993 26.9436 11.8845 28V18.1568H8.30812V14.0853H11.8845V10.9821C11.8845 7.45255 13.9862 5.50206 17.205 5.50206C18.7455 5.50206 20.3576 5.77717 20.3576 5.77717V9.24347H18.5805C16.8308 9.24347 16.2861 10.3301 16.2861 11.4443V14.0853H20.1926L19.5681 18.1568H16.2861V28C23.0206 26.9436 28.1706 21.1169 28.1706 14.0853Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"29","height":"28","viewBox":"0 0 29 28","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
